import { Card, Text, Collapse, Button, Group, Badge, Stack, Center, Loader } from "@mantine/core";
import { IconChevronDown, IconChevronUp, IconBriefcase } from "@tabler/icons-react";
import { useState } from "react";
import useGetProjetosByEmbaixador from "../../hooks/useGetProjetosByEmbaixador";

interface ProjetosRelacionadosCardProperties {
  embaixadorPessoaId?: string;
}

const ProjetosRelacionadosCard = ({ embaixadorPessoaId }: ProjetosRelacionadosCardProperties) => {
  const [opened, setOpened] = useState(false);
  const { data: projetos = [], isLoading } = useGetProjetosByEmbaixador(embaixadorPessoaId);

  const hasProjects = projetos && projetos.length > 0;
  const handleToggle = () => setOpened((previous) => !previous);

  return (
    <Card withBorder>
      <Group justify="space-between" mb="md">
        <Group gap="sm">
          <IconBriefcase size={20} />
          <Text fw={500} size="sm">
            Projetos Relacionados
          </Text>
          {hasProjects && (
            <Badge size="sm" variant="light" color="blue">
              {projetos.length}
            </Badge>
          )}
        </Group>

        <Button
          variant="subtle"
          size="xs"
          rightSection={opened ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
          onClick={handleToggle}
          disabled={!embaixadorPessoaId}
        >
          {opened ? "Recolher" : "Expandir"}
        </Button>
      </Group>

      <Collapse in={opened}>
        {isLoading ? (
          <Center py="md">
            <Loader size="sm" />
          </Center>
        ) : hasProjects ? (
          <Stack gap="xs">
            {projetos.map((projeto) => (
              <Group key={projeto.id} justify="space-between" p="xs" bg="gray.0" style={{ borderRadius: 4 }}>
                <div>
                  <Text size="sm" fw={500}>
                    {projeto.nome}
                  </Text>
                </div>
                <Badge size="sm" variant="dot" color="green">
                  Ativo
                </Badge>
              </Group>
            ))}
          </Stack>
        ) : (
          <Text size="sm" c="dimmed" ta="center" py="md">
            {embaixadorPessoaId
              ? "Este embaixador não está relacionado a nenhum projeto ainda."
              : "Salve o embaixador primeiro para ver os projetos relacionados."}
          </Text>
        )}
      </Collapse>
    </Card>
  );
};

export default ProjetosRelacionadosCard;
